import { isSsr } from './general';
export const getAuthorizationToken = () => { var _a, _b; return !isSsr ? ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.token) || '' : ''; };
export const getSvocId = () => { var _a, _b; return isSsr ? null : ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.svocID) || ''; };
export const getUserId = () => { var _a, _b; return isSsr ? null : ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.userID) || ''; };
export const getMemberId = () => {
    var _a, _b;
    if (isSsr)
        return null;
    const token = getAuthorizationToken();
    const svocId = getSvocId();
    if (token && svocId)
        return svocId;
    return ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.userID) || '';
};
export const isLoggedIn = () => { var _a, _b; return ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.isLoggedIn) || false; };
export const getEmail = () => { var _a, _b; return (_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.email; };
export const getCustomerIp = () => window.trueClientIp || '';
